<div class="bg-secondary border border-b border-primary">
  <div class="flex items-center py-3 container min-h-16">
    <app-icon class="mr-3 lg:mr-5 w-10 h-10 text-primary lg:hidden" name="burger" size="custom"
              (click)="toggleSidebar.emit()"></app-icon>
    <a [routerLink]="'/'" class="max-w-[220px]">
      <img [src]="'assets/images/logo.png'" alt="stalcraft trade logo" class="lg:block hidden">
      <img [src]="'assets/images/logo-short.png'" alt="stalcraft trade logo" class="lg:hidden w-8">
    </a>
    <ul class="gap-10 text-primary text-sm list-none ml-16 hidden lg:flex">
      <li>
        <a class="transition-colors duration-300 hover:text-corporate-400 gtm-menu-link"
           [routerLink]="'/auction/in-game'"
           [routerLinkActive]="'active'">
          {{ 'menu.auction' | transloco }}
        </a>
      </li>
    </ul>
    <div class="ml-auto flex">
      <button [matMenuTriggerFor]="languageMenu">
        <app-icon class="pointer-events-none block" name="language" size="md"></app-icon>
      </button>
    </div>
    @if (user$.value) {
      <button class="ml-7" [matMenuTriggerFor]="profileMenu">
        <div class="profile">
          <div class="avatar">
            <img src="../../../../assets/images/default-user.png" alt="avatar">
          </div>
          <span class="name">{{ (user$ | async)?.nickname }}</span>
        </div>
      </button>
    } @else {
      <ul class="flex items-center text-primary text-sm gap-3 ml-3 lg:gap-5 lg:ml-5">
        <li>
          <a routerLink="/login"
             class="transition-colors duration-300 hover:text-corporate-400"> {{ 'header.signIn' | transloco }}</a>
        </li>
        <li>
          <a routerLink="/register"
             class="transition-colors duration-300 hover:text-corporate-400"> {{ 'header.signUp' | transloco }}</a>
        </li>
      </ul>
    }
  </div>
</div>

<mat-menu #profileMenu="matMenu">
  <ul class="menu">
    <li (click)="goTo('my-orders')">
      <app-icon name="trade" size="md"></app-icon>
      {{ 'header.myOrders' | transloco }}
    </li>
    <li (click)="goTo('settings')">
      <app-icon name="settings" size="md"></app-icon>
      {{ 'header.settings' | transloco }}
    </li>
    <li (click)="logOut()">
      <app-icon name="exit" size="md"></app-icon>
      {{ 'header.exit' | transloco }}
    </li>
  </ul>
</mat-menu>

<mat-menu #languageMenu="matMenu">
  <ul class="menu">
    <li (click)="changeLanguage('ru')">
      <app-icon name="ru-flag" size="sm"></app-icon>
      Русский
    </li>
    <li (click)="changeLanguage('en')">
      <app-icon name="en-flag" size="sm"></app-icon>
      English
    </li>
  </ul>
</mat-menu>
